import React from "react"

function DeskSliderPanel(props) {
    const sliderData = [
        {
            id: 0,
            sliderValue: props.sliderValue.sliderOne,
            name: "sliderOne"
        },
        {
            id: 1,
            sliderValue: props.sliderValue.sliderTwo,
            name: "sliderTwo"
        },
        {
            id: 2,
            sliderValue: props.sliderValue.sliderThree,
            name: "sliderThree"
        },
        {
            id: 3,
            sliderValue: props.sliderValue.sliderFour,
            name: "sliderFour"
        },
        {
            id: 4,
            sliderValue: props.sliderValue.sliderFive,
            name: "sliderFive"
        }
    ]
    
    const sliders = sliderData.map(slider => {
        return (
            <input key={slider.id} type="range" min="1" max="3" value={slider.sliderValue} className="deskSwitches" id={slider.name} onChange={props.handleChange} />
        )
    })

    return (
        <div className="imageTextWrapper deskSliderWrapper">
            <div className="switchSymbol switchSymbolCircle"></div>
            <div className="switchSymbol switchSymbolTriangle"></div>
            <div className="switchSymbol switchSymbolSquare"></div>

            <div className="slideContainer">
                {sliders}
            </div>
        </div>
    )
}

export default DeskSliderPanel